import flow from 'lodash/fp/flow.js';
import filter from 'lodash/fp/filter.js';
import join from 'lodash/fp/join.js';
import map from 'lodash/fp/map.js';
import sortBy from 'lodash/fp/sortBy.js';
import compact from 'lodash/compact.js';
import pickBy from 'lodash/pickBy.js';
import flatMap from 'lodash/fp/flatMap.js';
import getExpConfig from './getExpConfig';

const createImageName = ({ optionId, choiceId }) => {
  if (!optionId || !choiceId) {
    return '';
  }
  return `${optionId}_${choiceId}`;
};
export const getThumbnailUrl = (selections) => {
  const s3ImageObject = flow(
    sortBy('optionId'),
    filter((selection) => selection.optionTags?.includes('ordersummary-thumbnail')),
    map(createImageName),
    join('_')
  )(selections);
  return `${getExpConfig('amazon-s3-media-assets-bucket-url')}Thumbnails/${s3ImageObject}.png`;
};

const uploadedSides = (choiceValue) => {
  const sides = pickBy(choiceValue);
  return Object.keys(sides)
    .map((side) => `${side} Logo`)
    .join(', ');
};
export const getSelections = (lineItem) => {
  const selections = flow(
    sortBy('optionId'),
    sortBy((selection) => (selection.optionTags.includes('uploadlogo') ? 0 : 1)),
    compact((selection) => selection.optionTags.indexOf('notskumapped') < 0),
    flatMap((selection) =>
      selection.optionTags.includes('uploadlogo')
        ? uploadedSides(selection.choiceValue)
        : selection.choiceValue
    ),
    compact(Boolean),
    join(', ')
  )(lineItem.selections);

  return selections;
};
